import { useEffect } from "react";
import PropTypes from "prop-types";
import labels from "../../../config/labels";
import {
  formatNumbersWithComma,
  isArrayNotEmpty,
} from "../../../utils/helperServices";
import ButtonPayment from "../../../components/organisms/buttonPayment/ButtonPayment";
import styles from "./CheckoutOrderSummary.module.scss";

const CheckoutOrderSummary = ({
  variant,
  subTotal,
  totalSaving,
  delivery,
  total,
  onClickSubmit,
  navigate,
  btnSecure,
  btnPayment,
  btnDisabled,
  btnLable,
  btnType,
  monthlyCartProducts,
  dealProducts,
  onceOffCartProducts,
  contractType,
  pageType,
  customerStatus,
  setPageErr,
  currentJourneyType,
  shippingAddress,
  addressTypes,
  cartDetails,
  showOnceOffProducts,
  buttonPaymentPageName,
  paymentOptionsEnabled,
  continueDisable,
}) => {
  useEffect(() => {
    if (variant == "pop-up") {
      var dragDiv = document.getElementById("checkout-summary");
      dragDiv.addEventListener("touchstart", onTouchStart, false);

      return () => {
        dragDiv.removeEventListener("touchstart", onTouchStart);
      };
    }
  });

  const dealProduct = monthlyCartProducts.find(
    (cartProduct) => cartProduct?.product?.is_deal_product === 1
  );
  const dealSku = dealProduct?.product?.sku;
  let vasPrice,
    dealVasPrice = 0;
  const dealVasProduct = monthlyCartProducts.filter(
    (cartProduct) => cartProduct?.parent_product_sku == dealSku
  );

  if (dealVasProduct) {
    dealVasPrice = dealVasProduct.reduce((accu, ele) => {
      if (dealSku && ele?.parent_product_sku == dealSku) {
        accu += ele?.monthly_recurring;
        return accu;
      }
    }, 0);
  }

  let isSimonlyUpgrade = monthlyCartProducts[0]?.product?.deal_delivery && monthlyCartProducts.length === 1 && !(contractType === "Upgrade" && monthlyCartProducts[0]?.product?.sim_only_flg);
  let dealPrice, contractDuration, totalDealPrice, firstMonthTotal;
  if (pageType == "contract") {
    let monthy =
      monthlyCartProducts && monthlyCartProducts.length > 1 ? true : false;

    if (monthy) {
      let counter = 0;
      monthlyCartProducts.forEach((item) => {
        if (item?.product?.is_deal_product === 1) {
          counter++;
        }
      });
      monthy = counter == 1;
    } else {
      monthy =
        monthlyCartProducts && monthlyCartProducts.length == 1 ? true : false;
    }

    if (monthy) {
      dealPrice = `R${formatNumbersWithComma(
        Math.round(dealProduct?.product?.monthly_recurring * 100) / 100
      )}`;
      contractDuration = `${dealProduct?.product?.payment_terms_label} months`;
      if (dealVasPrice) {
        vasPrice = parseFloat(dealVasPrice);
        vasPrice = `R${formatNumbersWithComma(
          Math.round(vasPrice * 100) / 100
        )}`;
        dealVasPrice =
          parseFloat(dealProduct?.product?.monthly_recurring) +
          parseFloat(dealVasPrice);
        dealVasPrice = `R${formatNumbersWithComma(
          Math.round(dealVasPrice * 100) / 100
        )}`;
        totalDealPrice = `${dealVasPrice} × ${dealProduct?.product?.payment_terms_label}`;
      } else {
        totalDealPrice = `${dealPrice} × ${dealProduct?.product?.payment_terms_label}`;
      }
    } else {
      dealPrice = "-";
      contractDuration = "-";

      totalDealPrice = `R${formatNumbersWithComma(0)}`;
    }
  }
  
  if(dealProduct?.product?.deal_delivery){
      firstMonthTotal = parseInt(totalDealPrice.replace(/^\D+/g, "").replace(/,/g, '')) + parseInt(dealProduct?.product?.deal_delivery?.replace(/^\D+/g, ""))
  }

  const totalOnceOffItems = onceOffCartProducts.reduce(
    (acc, curr) => acc + curr?.quantity,
    0
  );

  const RenderDiv = (label, value, subLabel) => (
    <div className={styles["wrapper"]} id={`${label}-parent-checkout`}>
      <div className={styles["label"]} id={`${label}-child-checkout`}>
        {label}
      </div>
      <div className={styles["value"]} id={`${value}-value-checkout`}>
        {value}
        {subLabel ? " " + subLabel : ""}
      </div>
    </div>
  );

  const RenderWrapper = (label, value, subLabel) => (
    <div
      className={`${styles["wrapper"]} ${
        label === "Delivery:" ? styles["delivery-lbl-spacing"] : ""
      }`}
      id={`${label}-parent-checkout`}
    >
      <div
        className={`${styles["wrapper-label"]}`}
        id={`${label}-child-checkout`}
      >
        {label}
      </div>
      <div
        className={`${styles["wrapper-value"]}`}
        id={`${value}-value-checkout`}
      >
        {value}
        {subLabel ? " " + subLabel : ""}
      </div>
    </div>
  );

  const navigateToNextPage = () => {
    if (onClickSubmit) {
      onClickSubmit();
    }
  };

  function onTouchStart(e) {
    let openClass = styles["open"];
    if (
      !e.target.classList.contains(styles["continue-button"]) &&
      !e.target.classList.contains(styles["button-label"])
    ) {
      // eslint-disable-next-line no-undef
      $("#checkout-summary").toggleClass(openClass);
    }
  }

  return (
    <>
      <div
        draggable="true"
        className={`${styles["checkout-summary"]} ${styles[variant]}`}
        id="checkout-summary"
      >
        <div className={styles["swipe"]}>&nbsp;</div>
        <label
          className={
            pageType == "contract" ? styles["wrapper-title"] : styles["title"]
          }
        >
          {labels.lbl_order_summary}
        </label>

        {isArrayNotEmpty(monthlyCartProducts) && cartDetails.contract && (
          <>
            <>
              {RenderWrapper(labels.lbl_app_type, contractType)}
              {RenderWrapper(labels.lbl_contract_duration, contractDuration)}
              {dealVasPrice != 0 && (
                <>{RenderDiv(labels.lbl_add_Ons, vasPrice)}</>
              )}
              {RenderWrapper(labels.lbl_monthly_subtotal, totalDealPrice)}
              <div className={styles["horizantal-line"]} />
            </>
          </>
        )}

        {isArrayNotEmpty(onceOffCartProducts) &&
          cartDetails.onceOff &&
          showOnceOffProducts && (
            <>
              {RenderDiv(
                cartDetails?.isMulti
                  ? "No. once-off items:"
                  : labels.lbl_no_items,
                totalOnceOffItems,
                "item"
              )}

              {isArrayNotEmpty(monthlyCartProducts) &&
                RenderDiv(labels.lbl_onceoff_subtotal, subTotal)}

              <div className={styles["horizantal-line"]} />

              {totalSaving
                ? RenderDiv(labels.lbl_total_saving, totalSaving)
                : ""}
            </>
          )}

        {isArrayNotEmpty(onceOffCartProducts) && !cartDetails?.isMulti
          ? RenderDiv(labels.lbl_sub_total, subTotal)
          : null}
        {delivery && isArrayNotEmpty(onceOffCartProducts)
          ? RenderDiv(labels.lbl_delivery, delivery)
          : ((monthlyCartProducts[0]?.product.deal_delivery && isSimonlyUpgrade) && RenderDiv("Delivery fee (once-off):", "R"+formatNumbersWithComma(monthlyCartProducts[0]?.product.deal_delivery?.replace(/^\D+/g, ""))))
          }
      {(monthlyCartProducts[0]?.product.deal_delivery && isSimonlyUpgrade)&& <div
          className={`${styles["horizantal-line"]} ${styles["total-line"]}`}
        />}
        

        {isArrayNotEmpty(monthlyCartProducts) && cartDetails.contract && (
          <>
          
          
          {(monthlyCartProducts[0]?.product.deal_delivery && isSimonlyUpgrade) &&  
          <div
            className={`${styles["wrapper"]} ${styles["wrapper-total"]}`}
            id={`checkout-order-summary-amount-wrapper`}
          >
            <div
              className={styles["total-value"]}
              id={`checkout-order-summary-amount-label`}
            >
              {"First month's total:"}
            </div>
            <div
              className={styles["total-value"]}
              id={`checkout-order-summary-total-amount`}
            >
              {"R" + formatNumbersWithComma(firstMonthTotal)  }
            </div>
          </div>
          }
          
          <div
            className={`${styles["wrapper"]} ${styles["wrapper-total"]}`}
            id={`checkout-order-summary-amount-wrapper`}
          >
            <div
              className={styles["total-value"]}
              id={`checkout-order-summary-amount-label`}
            >
              {labels.lbl_monthly_total}
            </div>
            <div
              className={styles["total-value"]}
              id={`checkout-order-summary-total-amount`}
            >
              {totalDealPrice}
            </div>
          </div>
          </>
        )}

        {isArrayNotEmpty(onceOffCartProducts) &&
          cartDetails.onceOff &&
          showOnceOffProducts && (
            <div
              className={`${styles["wrapper"]} ${styles["wrapper-total"]}`}
              id={`checkout-order-summary-amount-wrapper`}
            >
              <div
                className={styles["total"]}
                id={`checkout-order-summary-amount-label`}
              >
                {labels.lbl_total_due}
              </div>
              <div
                className={styles["total"]}
                id={`checkout-order-summary-total-amount`}
              >
                {total ? total : `R${formatNumbersWithComma(0)}`}
              </div>
            </div>
          )}

        {!btnPayment ? (
          <button
            className={`${styles["continue-button"]}`}
            onClick={navigateToNextPage}
            disabled={btnDisabled}
            type={btnType}
            id={`${btnLable}-checkout-btn`}
          >
            <label className={styles["button-label"]}>{btnLable}</label>
          </button>
        ) : (
          <ButtonPayment
            btnSecure={btnSecure}
            btnLable={btnLable}
            btnDisabled={btnDisabled}
            navigate={navigate}
            customerStatus={customerStatus}
            deal={dealProducts}
            dealID={
              dealProducts &&
              dealProducts?.length &&
              dealProducts[0]?.product?.sku
            }
            applicationType={pageType}
            setPageErr={setPageErr}
            currentJourneyType={currentJourneyType}
            shippingAddress={shippingAddress}
            addressTypes={addressTypes}
            pageName={buttonPaymentPageName}
            paymentOptionsEnabled={paymentOptionsEnabled}
            continueDisable={continueDisable}
          />
        )}
      </div>
    </>
  );
};

CheckoutOrderSummary.propTypes = {
  addressTypes: PropTypes.arrayOf(PropTypes.object),
  btnDisabled: PropTypes.bool,
  btnLable: PropTypes.string,
  btnPayment: PropTypes.bool,
  btnSecure: PropTypes.bool,
  btnType: PropTypes.string,
  buttonPaymentPageName: PropTypes.string,
  cartDetails: PropTypes.shape({
    contract: PropTypes.bool,
    onceOff: PropTypes.bool,
    isMulti: PropTypes.bool,
  }),
  continueDisable: PropTypes.func,
  contractType: PropTypes.string,
  currentJourneyType: PropTypes.string,
  customerStatus: PropTypes.string,
  delivery: PropTypes.string,
  dealProducts: PropTypes.arrayOf(PropTypes.object),
  monthlyCartProducts: PropTypes.arrayOf(PropTypes.object),
  navigate: PropTypes.func,
  onceOffCartProducts: PropTypes.arrayOf(PropTypes.object),
  onClickSubmit: PropTypes.func,
  pageType: PropTypes.string,
  paymentOptionsEnabled: PropTypes.bool,
  setPageErr: PropTypes.func,
  shippingAddress: PropTypes.object,
  showOnceOffProducts: PropTypes.bool,
  subTotal: PropTypes.string,
  total: PropTypes.string,
  totalSaving: PropTypes.string,
  variant: PropTypes.oneOf(["pop-up", "plain"]),
};

CheckoutOrderSummary.defaultProps = {
  variant: "pop-up",
  btnClass: "",
  btnDisabled: false,
  btnSecure: false,
  btnLable: "Continue",
  btnType: "submit",
  pageType: "normal",
  showOnceOffProducts: true,
};

export default CheckoutOrderSummary;
